// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circular-carousel[data-v-61bd9cf7]{position:relative}.circular-carousel__item[data-v-61bd9cf7]{overflow:hidden;display:block;position:absolute;line-height:1}.circular-carousel__item.transition[data-v-61bd9cf7],.circular-carousel__item img[data-v-61bd9cf7]{-webkit-transition:all .35s ease;-moz-transition:all .35s ease;-o-transition:all .35s ease;transition:all .35s ease}.circular-carousel__item img[data-v-61bd9cf7]{vertical-align:top}", ""]);
// Exports
module.exports = exports;
